var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12.5C10 12.7761 9.77614 13 9.5 13L1.5 13C1.22386 13 1 12.7761 1 12.5L1 3.5C1 3.22386 1.22386 3 1.5 3L9.5 3C9.77614 3 10 3.22386 10 3.5L10 5.5C10 5.77614 10.2239 6 10.5 6C10.7761 6 11 5.77614 11 5.5L11 3.5C11 2.67157 10.3284 2 9.5 2L1.5 2C0.671574 2 4.95181e-07 2.67157 4.5897e-07 3.5L6.55671e-08 12.5C2.93554e-08 13.3284 0.671573 14 1.5 14L9.5 14C10.3284 14 11 13.3284 11 12.5L11 10.5C11 10.2239 10.7761 10 10.5 10C10.2239 10 10 10.2239 10 10.5L10 12.5Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8536 8.35355C16.0488 8.15829 16.0488 7.84171 15.8536 7.64645L12.8536 4.64645C12.6583 4.45118 12.3417 4.45118 12.1464 4.64645C11.9512 4.84171 11.9512 5.15829 12.1464 5.35355L14.2929 7.5L5.5 7.5C5.22386 7.5 5 7.72386 5 8C5 8.27614 5.22386 8.5 5.5 8.5L14.2929 8.5L12.1464 10.6464C11.9512 10.8417 11.9512 11.1583 12.1464 11.3536C12.3417 11.5488 12.6583 11.5488 12.8536 11.3536L15.8536 8.35355Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs);
export default __webpack_public_path__ + "static/media/cs.97c71dd385ccf33f26eb476b9cd74d6d.svg";
export { ForwardRef as ReactComponent };